import { useEffect } from 'react';

export const usePreventScroll = (enabled = true) => {
  useEffect(() => {
    if (!enabled) return;

    const preventDefault = (e) => {
      // Allow touch on specific interactive elements if needed, 
      // but for this game we want to block mostly everything global
      if (e.target.tagName === 'BUTTON' || e.target.closest('[data-interactive="true"]')) {
        return;
      }
      if (e.cancelable) {
        e.preventDefault();
      }
    };

    // Options to ensure we can prevent default
    const options = { passive: false };

    // Block touchmove to prevent scrolling
    document.addEventListener('touchmove', preventDefault, options);
    // Block touchstart to prevent double-tap zoom etc
    document.addEventListener('touchstart', preventDefault, options);
    // Block wheel for good measure
    document.addEventListener('wheel', preventDefault, options);
    // Block context menu (long press)
    document.addEventListener('contextmenu', preventDefault, options);

    return () => {
      document.removeEventListener('touchmove', preventDefault);
      document.removeEventListener('touchstart', preventDefault);
      document.removeEventListener('wheel', preventDefault);
      document.removeEventListener('contextmenu', preventDefault);
    };
  }, [enabled]);
};